var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#000000;stroke-linecap:round;stroke-width:1.5px;}.cls-1{stroke-linejoin:bevel;}.cls-2{stroke-linejoin:round;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-contact-mail"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 5,
    width: 20,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.58,5.59l8.23,8.22a2,2,0,0,0,2.83,0l8-8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.dedd7762361a73c2a0eda838e47a0196.svg";
export { ForwardRef as ReactComponent };